import React from "react"
import Typography from "@material-ui/core/Typography"
import Paper from "@material-ui/core/Paper"
import CircularProgress from "@material-ui/core/CircularProgress"

const AwaitingContainer = ({ classes }) => {
    return (
        <div className={classes.bigContainer}>
            <Paper className={classes.paper}>
                <div
                    style={{ display: "flex", justifyContent: "center" }}
                >
                    <div style={{ textAlign: "center" }}>
                        <React.Fragment>
                            <div style={{ marginBottom: 32 }}>
                                <Typography
                                    variant="h6"
                                    style={{ fontWeight: "bold" }}
                                    gutterBottom
                                >
                                    Por favor, aguarde
                                </Typography>
                            </div>
                            <CircularProgress
                                style={{
                                    marginBottom: 32,
                                    width: 100,
                                    height: 100
                                }}
                            />
                        </React.Fragment>

                    </div>
                </div>
            </Paper>
        </div>
    );
}

export default AwaitingContainer;